import { Search, X } from "lucide-react";
import { useMemo, useState } from "react";
import type { EditorOption } from "@/lib/domain/editor";
import styles from "./editor/relation-picker.module.css";

export function RelationPicker({
  label,
  description,
  options,
  values,
  onChange,
}: {
  label: string;
  description?: string;
  options: EditorOption[];
  values: string[];
  onChange: (values: string[]) => void;
}) {
  const [query, setQuery] = useState("");
  const visible = useMemo(
    () =>
      options
        .filter((option) =>
          option.label
            .toLocaleLowerCase("tr")
            .includes(query.toLocaleLowerCase("tr")),
        )
        .slice(0, 100),
    [options, query],
  );
  const selected = useMemo(
    () => values.map((value) => options.find((option) => option.id === value)).filter((option): option is EditorOption => Boolean(option)),
    [options, values],
  );
  return (
    <fieldset className={`${styles.root} relation-picker`}>
      <legend>{label}</legend>
      {description && <p className={styles.description}>{description}</p>}
      {selected.length > 0 ? <div className={styles.selected} aria-label={`${label} seçimleri`}>{selected.map((option) => <span className={styles.chip} key={option.id}>{option.label}<button type="button" aria-label={`${option.label} seçimini kaldır`} onClick={() => onChange(values.filter((value) => value !== option.id))}><X size={13} /></button></span>)}</div> : null}
      <div className="relation-search">
        <Search size={16} />
        <input
          className="ui-input"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder={`${label} içinde ara…`}
        />
      </div>
      <div className="relation-options">
        {visible.map((option) => (
          <label className="relation-option" key={option.id}>
            <input
              type="checkbox"
              checked={values.includes(option.id)}
              onChange={(event) =>
                onChange(
                  event.target.checked
                    ? [...values, option.id]
                    : values.filter((value) => value !== option.id),
                )
              }
            />
            <span>
              {option.depth
                ? `${"— ".repeat(option.depth)}${option.label}`
                : option.label}
            </span>
          </label>
        ))}
        {visible.length === 0 ? <div className={styles.empty}>Eşleşen kayıt bulunamadı.</div> : null}
      </div>
      <div className={styles.summary}><span>{values.length ? `${values.length} seçim` : "Henüz seçim yapılmadı"}</span>{values.length ? <button type="button" className={styles.clear} onClick={() => onChange([])}>Tümünü temizle</button> : null}</div>
    </fieldset>
  );
}
